// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreakerControl {
  border-bottom: 1px solid #353535;
  margin-bottom: 10px;
  font-style: italic;
}
.BreakerControl h2 {
  font-size: 20px;
  font-weight: bold;
  color: #353535;
}
.BreakerControl p {
  font-size: 14px;
  font-weight: normal;
  color: #353535;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/LineBreaker.less"],"names":[],"mappings":"AAEA;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAFA;EAMI,eAAA;EACA,iBAAA;EACA,cAAA;AADJ;AAPA;EAYI,eAAA;EACA,mBAAA;EACA,cAAA;AAFJ","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.BreakerControl {\n  border-bottom: 1px solid @background-dark1;\n  margin-bottom: 10px;\n  font-style: italic;\n\n  h2 {\n    font-size: 20px;\n    font-weight: bold;\n    color: @text-gray1;\n  }\n\n  p {\n    font-size: 14px;\n    font-weight: normal;\n    color: @text-gray1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
